import { useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { billingApi, PLAN_INFO, type PlanTier } from '@/features/billing/billing.api';
import { extractError } from '@/lib/axios';

export default function BillingSection(): JSX.Element {
  const { data, isLoading } = useQuery({ queryKey: ['billing', 'subscription'], queryFn: () => billingApi.getSubscription() });

  const upgrade = async (tier: PlanTier) => {
    try {
      const url = await billingApi.checkout(tier as Exclude<PlanTier, 'FREE'>);
      window.location.href = url;
    } catch (err) {
      toast.error(extractError(err).message);
    }
  };

  const manage = async () => {
    try {
      window.location.href = await billingApi.portal();
    } catch (err) {
      toast.error(extractError(err).message);
    }
  };

  return (
    <div className="card">
      <h3 className="font-semibold">Subscription & billing</h3>
      {isLoading ? (
        <p className="mt-2 text-sm text-slate-500">Loading…</p>
      ) : (
        <>
          <p className="mt-2 text-sm">
            Current plan: <span className="font-semibold text-brand-600">{data?.tier}</span> ({data?.status})
          </p>
          {data?.tier !== 'FREE' && (
            <p className="text-xs text-slate-500">
              {data?.cancelAtPeriodEnd ? 'Cancels' : 'Renews'} {data?.currentPeriodEnd ? new Date(data.currentPeriodEnd).toLocaleDateString() : ''}
            </p>
          )}
          <div className="mt-4 flex flex-wrap gap-2">
            {PLAN_INFO.filter((p) => p.tier !== 'FREE' && p.tier !== data?.tier).map((p) => (
              <button key={p.tier} className="btn-ghost border border-slate-300 dark:border-slate-700" onClick={() => upgrade(p.tier)}>
                Switch to {p.name} ({p.price})
              </button>
            ))}
            {data?.tier !== 'FREE' && (
              <button className="btn-primary" onClick={manage}>Manage billing</button>
            )}
          </div>
        </>
      )}
    </div>
  );
}
